import type { EmbeddedSchemaType } from '@vedalib/editor/lib/brand'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import Element from './EmbeddedElement'

const EmbeddedDemo: FCDemoType<EmbeddedSchemaType> = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.embedded.type}-demo`,
        type: CONFIG_ELEMENTS.embedded.type,
        value: CONFIG_ELEMENTS.embedded.defaultValue,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default EmbeddedDemo
